import { applySdkMetadata } from '@sentry/core';
import { init as init$1 } from '@sentry/react';

/**
 * Initializes the Remix SDK.
 * @param options The configuration options.
 * @returns The initialized SDK.
 */
function init(options) {
  const opts = {
    ...options,
    environment: options.environment || process.env.NODE_ENV,
  };

  applySdkMetadata(opts, 'remix', ['remix', 'react']);

  return init$1(opts);
}

export { init };
//# sourceMappingURL=sdk.js.map
